export default "__VITE_ASSET__CYkUTIvR__"